// export const OnboardingWelcome = () => import('./Onboarding')
import { Onboarding } from './Onboarding'
import { DialogTermsAndCondition } from './Dialog'
import { FollowingGold } from './Following'
import { BoxAsset } from './Box'

export { 
    Onboarding, 
    DialogTermsAndCondition, 
    FollowingGold,
    BoxAsset
}
